<template lang="pug">
	div.tab-wrap
		v-layout.tab-container(
			column
			align-center
		)

			.direction-layer.fill-height
				.make-title(
					v-if="directions.length > 0"
				) 검수 할 프로젝트를 선택하세요

				v-layout.direction-wrap(
					v-if="directions.length > 0"
					column
				)
					.legend
						v-image(src="make_project_legend.png")
					.directions(
						v-for="type in ['low', 'medium', 'high']"
						:key="type"
					)
						v-layout.direction(
							justify-center
							align-center
							v-for="(direction, index) in directionItems[type]"
							:key="index"
							:class="`${selectedClass(direction)} ${completedClass(direction)}`"
							@click="selectItem(direction)"
						) {{ names[type] }}{{ direction.order }}
						.direction-name(v-if="directionItems[type].length === 0") {{ names[type] }}
				.empty(v-else)
					span 진행 중인 프로젝트가 없어요

</template>

<script>

    export default {
        data() {
            return {
                directions: [],
                names: { low: '하', medium: '중', high: '상'},
                selected: null,
                directionItems: { low :[], medium: [], high: [] },

	            dialogId: -1,
            }
        },

        computed: {
            mqttData() {
                return this.$gameData.mqttData
            },

        },
        watch: {
            mqttData(val) {
                // MQTT 재연결·화면 복귀 — 공백 구간에 놓친 상태를 REST로 복구하고
                // 열어둔 지시서가 그 사이 서버에서 닫혔는지 대조한다
                if (val && val.action === 'reconnected') {
                    this.recheckOpenDirection()
                    return
                }
                // 관리자 상태 초기화 — 서버 상태로 다시 맞추고, 그 지시서를 보고 있었다면 닫는다
                if (val && val.action === 'direction_reset' && val.part === 'make') {
                    this.getTeamDirections()

                    if (this.selected && this.selected.type === val.type && this.selected.order === val.order) {
                        this.closeDirectionLocally()
                    }
                    return
                }
                if (val && val.action === 'direction' && (val.target === 'part' && val.part === 'make' || val.target
	                === 'team' && val.part === 'buy'
                )) {
                    if (val.target === 'team') {
	                    this.$getUserData()
	                    this.getTeamDirections()
                    } else if (val.target === 'part') {

	                    if (val.make_status !== undefined) {
		                    if (this.selected && this.selected.type === val.type && this.selected.order === val.order) {

			                    if (val.inspected && val.user_id !== this.user.id) {
				                    this.selected = null
				                    this.$hideDialog(this.dialogId)
			                    } else {
				                    this.directions.find(v => v.type === val.type && v.order === val.order).make_status = val.make_status
			                    }
		                    } else {
			                    this.directions.find(v => v.type === val.type && v.order === val.order).make_status = val.make_status
		                    }
	                    }
                    }
	                
                } else if (val && val.action === 'inspection') {
	                if (val.type && val.order) {
		                this.getTeamDirections()
	                }
                }

                // this.$gameData.mqttData = null
            }
        },

        beforeDestroy() {
            this.unLoadEvent()
            $(window).off('beforeunload pagehide', this.unLoadEvent)
        },

        async mounted() {
            // pagehide 도 함께 — 모바일은 화면을 끄거나 앱을 전환할 때 beforeunload 를 발생시키지 않는다.
            $(window).on('beforeunload pagehide', this.unLoadEvent)
            await this.getTeamDirections()
        },

        methods: {
            /**
             * 열어둔 지시서의 화면 상태만 닫는다(서버 발행 없음).
             * 서버 쪽 닫기는 호출부가 이미 처리했거나(언로드) 서버가 먼저 닫은 경우다.
             */
            closeDirectionLocally() {
                this.selected = null
                this.$hideDialog(this.dialogId)
            },

            /**
             * 재연결·화면 복귀 후 열어둔 지시서를 서버 상태와 대조해, 이미 닫혔으면 화면도 닫는다.
             * 언로드 시 로컬 닫기가 실행되지 못한 경우(비컨만 도착, 관리자 초기화 등)의 안전망이다.
             */
            async recheckOpenDirection() {
                await this.getTeamDirections()
                if (!this.selected) return

                // getTeamDirections 는 배열을 통째로 교체하므로 새 목록에서 다시 찾는다.
                // 목록에서 사라졌다면(구매 상태가 되돌려짐) 그것도 닫힌 것이다.
                const item = this.directions.find(v => v.type === this.selected.type && v.order === this.selected.order)
                // 열림 판정은 engine 의 기준과 같아야 한다 — make 는 make_status 1 이고 검사 전일 때만 열림
                if (item && item.make_status === 1 && !item.inspected) return

                console.log('서버에서 이미 닫힌 지시서 — 화면을 닫는다, type =', this.selected.type,
                    ', order =', this.selected.order, ', make_status =', item ? item.make_status : 'not found')
                this.closeDirectionLocally()
            },

            unLoadEvent(e) {
                if (!this.selected) return

                this.selected.make_status = 0
                this.selected.inspected = 0
                this.selected.part = 'make'
                this.selected.user_id = this.user.id

                // this.$publishMqtt('part', 'direction', this.selected)
	            this.$publishDirection('part', 'make', this.selected)
	            // 언로드 중 MQTT 는 유실될 수 있다 — 전송이 보장되는 비컨으로도 닫는다(멱등)
	            this.$sendCloseBeacon('make', this.selected)
	            // 서버에 닫기를 보냈으면 화면도 함께 닫는다.
	            //   pagehide 는 "곧 파기된다"는 뜻이 아니다 — 모바일 크롬의 앱 전환은 페이지를
	            //   freeze/BFCache 로 보관했다가 같은 Vue 인스턴스 그대로 되살린다. 화면만 열린 채
	            //   남으면 서버는 닫힘인데 나는 열려 있어 두 명이 같은 지시서를 열게 된다.
	            this.closeDirectionLocally()

                // if (e) {
                //     e.preventDefault();
	            //     e.returnValue = undefined;
                // }
				//
				// return undefined
	            return

            },
            async getTeamDirections() {
                let response
                response = await this.$get('/team/directions')

                this.$set(this, 'directions', response.data.filter(v => v.buy_status === 2 || v.buy_status === 3))

                let items = {low: [], medium: [], high: []}
                for (let type of ['low', 'medium', 'high']) {
                    this.directions.forEach(direction => {
                        if (direction.type === type) items[type].push(direction)
                    })

                    items[type].sort((a, b) => {
                        return a.order > b.order ? 1 : -1;
                    })
                }

                this.directionItems = items
            },
            selectedClass(item) {
                if (item.make_status === 1) return 'selected'
                if (this.selected && this.selected.type === item.type && this.selected.order === item.order) return 'selected'

                return ''
            },
            completedClass(item){
                if (item.make_status === 2) return 'completed'
                return ''
            },
            selectItem(item) {
                if (item.make_status === 1) {
                    this.$showToast('make1')
                    return
                } else if (item.make_status === 2) {
                    return
                }

                this.selected = item
                item.make_status = 1
                item.inspected = 0
                item.part = 'make'
                item.user_id = this.user.id
                item.make_opened = moment().format('YYYY-MM-DD HH:mm:ss')

                // this.$publishMqtt('part', 'direction', item)
	            this.$publishDirection('part', 'make', item)

                this.dialogId = this.$showDialog({
                    type: 'make1',
                    message: `&nbsp;\n검수할 프로젝트는 [${this.names[item.type]}${item.order}]입니다`,
                    align: 'left',
                    color: '#969696',
                    buttons: [
                        { type: 'cancel', click: _ =>{
                                if (item.make_status === 1) {
                                    item.make_status = 0
                                    item.inspected = 0
                                }
                                // this.$publishMqtt('part', 'direction', item)
		                        this.$publishDirection('part', 'make', item)
                                this.selected = null
                            }},
                        { type: 'request', click: this.inspection},
                    ]
                })
            },

            inspection() {
                if (this.user.capital < 100) {
                    this.selected.make_status = 0
                    this.selected.inspected = 0
                    this.selected.part = 'make'
                    this.selected.user_id = this.user.id

                    // this.$publishMqtt('part', 'direction', this.selected)
	                this.$publishDirection('part', 'make', this.selected)
	                this.$showToast('point_not_enough')
                    this.selected = null
                    return
                }
                setTimeout(async _ => {

                    const response = await this.$post('/inspect/request', this.selected)
                    if (response.code !== '0000') {

	                    if (response.code === '9601') {
		                    this.$showToast('make1')
		                    this.selected = null
		                    return
	                    }

	                    this.selected.make_status = 0
                        this.selected.inspected = 0
                        this.selected.part = 'make'
                        this.selected.user_id = this.user.id

                        // this.$publishMqtt('part', 'direction', this.selected)
	                    this.$publishDirection('part', 'make', this.selected)

                        this.$showToast('point_not_enough')
                        this.selected = null
                        return
                    }
                    this.$publishMqtt('team', 'inspection', this.selected)

                    this.selected.make_status = 1
                    this.selected.inspected = 1
                    // this.$publishMqtt('part', 'direction', this.selected)
	                this.$publishDirection('part', 'make', this.selected)

                    this.selected = null
                    this.$showDialog({
                        type: 'make2',
                        buttons: [
                            { type: 'make2' },
                        ]
                    })
                }, 200)
            }
        }
    }
</script>

<style lang="scss" scoped>
	.tab-wrap {
		height: 100%;

		.make-title {
			margin-top: 20px;
			font-size: 22px;
			color: #5D5D5D;
		}

		.direction-wrap {
			padding-bottom: 150px;

			.legend {
				margin-top: 26px;
				text-align: right;
			}

			.directions {
				width: 522px;
				padding: 15px 0;

				&+.directions {
					border-top: 1px solid #D1D1D1;
				}

				.direction {
					display: inline-flex;
					width: 120px;
					height: 120px;
					background-color: #ffffff;
					border: 1px solid #D1D1D1;
					border-radius: 15px;
					font-size: 30px;
					margin: 5px;

					transition: background-color 0.5s, border-color 0.5s;

					&.selected {
						background-color: #FEC6C7;
						border-color: #FDA3A3;
					}
					&.completed {
						background-color: #C10D12;
						border-color: #A51116;
						color: #fff;
					}
				}
				.direction-name {
					text-align: center;
					font-size: 45px;
					color: #D1D1D1;
					margin-top: 37px;
					margin-bottom: 30px;
				}
			}
		}

		.empty {
			margin-top: 273px;
			font-size: 22px;
			color: #5D5D5D;
			text-align: center;

			.button {
				position: fixed;
				left: 0;
				bottom: 120px;
				width: 100%;

			}
		}

	}
</style>
